import DeleteIcon from '@mui/icons-material/Delete'
import EditNoteIcon from '@mui/icons-material/EditNote'
import { Backdrop, Button, Divider, Grid, IconButton, Typography } from '@mui/material'
import axios from 'axios'
import { useFormik } from 'formik'
import React, { Fragment, memo, useEffect, useState } from 'react'
import * as yup from 'yup'
import CustomDataGrid from '../../../../../components/dataTable/customDataGrid'
import City from '../../../../../components/utils/dropDown/city'
import Country from '../../../../../components/utils/dropDown/country'
import State from '../../../../../components/utils/dropDown/state'
import CustomTextField from '../../../../../components/utils/input/customTextField'
import Modal from '../../../../../components/utils/modal/modal'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import _ from 'lodash'
import DeletePage from '../../../../../components/utils/deleteModal/deletePage'
import Loader from '../../../../../components/loader/loader'
import { Helmet } from 'react-helmet-async'
const CompanyInfo = () => {
  const dispatch = useDispatch()
    const [data, setData] = useState([])
    const pageOption = [10,25,50,100]
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [search, setSearch] = useState('')
    const [open, setOpen] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [countryObj,setCountryObj] = useState(null)
    const [stateObj, setStateObj] = useState(null)
    const [cityObj, setCityObj] = useState(null);
    const [openDialog, setOpenDialog] = useState(false)
    const [activeId, setActiveId] = useState(null)
    const [bankId, setBankId] = useState(null)
    const [isLoader, setIsLoader] = useState(false); //loader


    const validation = yup.object({
      code : yup.string().matches(/^\S.*$/, "Empty space not allowed!")
      .required('This field is required!'),
      name: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
      shortName: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
      address1: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
      address2: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
      country: yup.object().required('Select anyone Country'),
      state:yup.object().required('Select anyone state'),
      city:yup.object().required('Select anyone city'),
     pincode: yup.string().matches(/^\S.*$/, "Empty space not allowed!") .matches(/^\d+$/, "Only digits are allowed")
      .min(6, "Minimum 10 digits required")
      .max(8, "Maximum 10 digits allowed")
      .required('This field is required!'),
      phone: yup.string().matches(/^\S.*$/, "Empty space not allowed!")
      .min(10, "Minimum 10 digits required")
      .max(10, "Maximum 10 digits allowed")
      .required('This field is required!'),
      mobile:yup.string().matches(/^\S.*$/, "Empty space not allowed!") .matches(/^\d+$/, "Only digits are allowed")
      .min(10, "Minimum 10 digits required")
      .max(10, "Maximum 10 digits allowed")
      .required('This field is required!'),
      email: yup.string("Enter your email").email("Enter a valid email").required("This field is required!"),
      website: yup.string()
      .matches(
          /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
          'Enter correct url!'
      )
      .required('This field is required!'),
      gstin:yup.string()
      .matches(/^([0][1-9]|[1-2][0-9]|[3][0-8])[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]/, 'Invalid GSTIN format')
      .required('This field is required!'),
      fssai:yup.string()
      .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, 'Invalid PAN number format')
      .required('PAN number is required'),
      bankAccNo:yup.string().matches(/^\d{9,18}$/, 'Invalid bank account number format').required('This field is required!'),
      bankName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
      accName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
      ifscCode:yup.string().matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code format').required('This field is required!'),
    })

    const formik = useFormik({
      initialValues:{
        code:'',
        name:'',
        shortName:'',
        country : null,
        state:null,
        city : null,
        address1:"",
        address2:"",
        address3:"-",
        address4:"-",
        pincode:"",
        phone:"",
        mobile:"",
        email: "",
        website:"",
        gstin:"",
        fssai:"",
        bankAccNo:"",
        bankName:"",
        accName:"",
        ifscCode:""
      },
      validationSchema: validation,
      onSubmit : isEdit ? handleUpdate : handleCreate
    })
    
    const columns = [
        {
          field: "sno",
          headerName: "S.no",
          minWidth: 70,
      
          headerAlign: "center",
          align: "center",
          sortable: false,
        },
        {
          field: "name",
          headerName: "Company Name",
          minWidth: 130,
          flex:1,
          headerAlign: "center",
          align: "center",
          sortable: false,
        },
        {
          field: "shortName",
          headerName: "Short Name",
          minWidth: 130,
          headerAlign: "center",
          align: "center",
          sortable: false,
        },
        {
          field: "country_name",
          headerName: "Country",
          minWidth: 130,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: "state_name",
          headerName: "State",
          minWidth: 130,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: "city_name",
          headerName: "City",
          minWidth: 130,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: "email",
          headerName: "Email",
          minWidth: 130,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: "phone",
          headerName: "Phone No.",
          minWidth: 130,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: "website",
          headerName: "Website",
          minWidth: 130,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: 'action',
          headerName: 'Action',
          minWidth: 130,
          minWidth: 100,
          headerAlign: "center",
          disableExport: true ,
          align: "center",
          editable: false,
          sortable: false,
          disableColumnMenu: true,
          renderCell: (params) => (
            <div className='flex justify-center w-full'>
              <IconButton onClick={()=>onEdit(params.row)} >
                <EditNoteIcon sx={{color:"#1972d2",fontSize:22}}/>
              </IconButton>
              <IconButton onClick={() => OnDelete(params.id)}>
                <DeleteIcon sx={{color:"red",fontSize:22}}/>
              </IconButton>
            </div>
          ),
        },
      ];
    
      const rows = _.map(data,(val,idx)=>({
        id: val.id,
        sno: ++idx,
        code:val.code,
        name: val.company_fullname,
        shortName: val.company_short_name,
        country:val.country,
        country_name: val.country_name,
        state: val.state,
        state_name: val.state_name,
        city: val.city,
        city_name: val.city_name,
        website:val.website,
        email: val.email,
        phone:val.phone,
        mobile:val.mobile,
        gstIn: val.gstin,
        fssai:val.fssai,
        pincode: val.pincode,
        bankDetails: val.bank_details,
        add1:val.add1,
        add2:val.add2,
        add3:val.add3,
        add4:val.add4,
      }))

      const props = {
        rows : rows,
        columns : columns,
        search : search,
        setSearch : setSearch,
        page: page,
        setPage : setPage,
        rowsPerPage : rowsPerPage,
        setRowsPerPage : setRowsPerPage,
        pageCount : pageCount,
        pageOption : pageOption
      }
     
const onCreate = ()=>{
setOpen(true)
formik.resetForm()
setIsEdit(false)
setCountryObj(null)
setCityObj(null)
setStateObj(null)
}
      
function handleCreate () {
  const companyData = {
    code: formik.values.code,
    company_short_name: formik.values.shortName,
    company_fullname: formik.values.name,
    add1: formik.values.address1,
    add2: formik.values.address2,
    add3: "-",
    add4: "-",
    city: formik.values.city.id,
    pincode: formik.values.pincode,
    state: formik.values.state.id,
    country: formik.values.country.id,
    phone: formik.values.phone,
    mobile: formik.values.mobile,
    email :formik.values.email,
    website: formik.values.website,
    gstin: formik.values.gstin,
    fssai: formik.values.fssai,
    bank_details: [
      {
        bankacno :formik.values.bankAccNo,
        bankname: formik.values.bankName,
        acname: formik.values.accName,
        ifsccode: formik.values.ifscCode
      }
    ]
  }
  setIsLoader(true);
axios.post('/v1/company',companyData)
.then(res=>{
  setOpen(false)
  getCompanyData()
  dispatch(setSnackbar(true, 'success','Created Successfully!'))
  setOpen(false)
  console.log(res)
  setIsLoader(false);
})
.catch(err=>{
  dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
  setIsLoader(false);
})
}
function onEdit(e){
  console.log(e)
  formik.setFieldValue('name',e.name)
  formik.setFieldValue('code',e.code)
  formik.setFieldValue('shortName', e.shortName)
  formik.setFieldValue('address1',e.add1)
  formik.setFieldValue('address2',e.add2)
  formik.setFieldValue('address3',"-")
  formik.setFieldValue('address4',"-")
  setCountryObj(e.country)
  setStateObj(e.state)
  setCityObj(e.city)
  formik.setFieldValue('pincode',e.pincode)
  formik.setFieldValue('phone',e.phone)
  formik.setFieldValue('mobile',e.mobile)
  formik.setFieldValue('email',e.email)
  formik.setFieldValue('website',e.website)
  formik.setFieldValue('gstin',e.gstIn)
  formik.setFieldValue('fssai',e.fssai)
  formik.setFieldValue('bankAccNo',e.bankDetails[0].bankacno)
  formik.setFieldValue('accName',e.bankDetails[0].acname)
  formik.setFieldValue('ifscCode',e.bankDetails[0].ifsccode)
  formik.setFieldValue('bankName',e.bankDetails[0].bankname)  
setBankId(e.bankDetails[0].id ? e.bankDetails[0].id : 0)
console.log(e.bankDetails[0].id)
setIsEdit(true)
setOpen(true)
setActiveId(e.id)
}

function handleUpdate(){
  const companyData = {
    code: formik.values.code,
    company_short_name: formik.values.shortName,
    company_fullname: formik.values.name,
    add1: formik.values.address1,
    add2: formik.values.address2,
    add3: "-",
    add4: "-",
    city: formik.values.city.id,
    pincode: formik.values.pincode,
    state: formik.values.state.id,
    country: formik.values.country.id,
    phone: formik.values.phone,
    mobile: formik.values.mobile,
    email :formik.values.email,
    website: formik.values.website,
    gstin: formik.values.gstin,
    fssai: formik.values.fssai,
    bank_details: [
      {
        bankacno :formik.values.bankAccNo,
        bankname: formik.values.bankName,
        acname: formik.values.accName,
        ifsccode: formik.values.ifscCode,
        bank_id : bankId
      }
    ]
  }
console.log('first')
setIsLoader(true);
axios.put(`/v1/company/${activeId}`,companyData)
.then(res=>{
  setOpen(false)
  getCompanyData()
  dispatch(setSnackbar(true, 'success','Updated Successfully'))
  setIsLoader(false);
})
.catch(err=>{
  dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
  console.log(err.response.data.errors[0].message)
  setIsLoader(false);
})
}
function OnDelete(id){
  setOpenDialog(true)
  setActiveId(id)
}    
const handleDelete = () =>{
  setIsLoader(true);
  axios.delete(`/v1/company/${activeId}`)
  .then(res=>{
    console.log(res)
    getCompanyData()
  dispatch(setSnackbar(true, 'success','Deleted Successfully'))
  setIsLoader(false);
  setOpen(false)
  })
  .catch(err=>{
    dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
    console.log(err)
    setIsLoader(false);
  })
  setOpenDialog(false)
  setActiveId(null)
}

const getCompanyData = () =>{
  const url = `/v1/company/${rowsPerPage}/${page + 1}`
  const searchUrl = `/v1/company/${rowsPerPage}/${page + 1}/${search}`
  axios.get(search === '' ? url : searchUrl)
      .then(res=>{
        setData(res.data.data)
        setPageCount(res.data.meta.pagination.total)
      })
      .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
      })
    }
    const handleMobile =(e)=>{
      formik.setFieldValue('mobile', e.target.value.replace(/\D/g, "").trim())
    }
    const handlePhone =(e)=>{
      formik.setFieldValue('phone', e.target.value.replace(/\D/g, "").trim())
    }

    const handleAcc =(e)=>{
      formik.setFieldValue('bankAccNo', e.target.value.replace(/\D/g, "").trim())
    }
useEffect(()=>{
  getCompanyData()
},[rowsPerPage, page, search])
console.log(formik.errors)
  return (
<Fragment>
  <Helmet>
    <title>Company Info</title>
  </Helmet>
  <Grid className='flex items-center justify-between'>
  <Typography variant='h5'>Company Info</Typography>
{!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
    </Grid>

{open &&
<Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit} setCountryObj={setCountryObj}>
<div style={{textAlign:"right"}}>
<Button  onClick={() => setOpen(false)}>Close</Button>
  </div>
  <Grid container spacing={2} >
 <Grid item xs={12}> <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>1. Company Details </Typography></Grid>
 <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='code' value={formik.values.code} title='Company Code *' multiple={false} placeholder='Enter company code' onchange={formik.handleChange} errorMsg={formik.touched.code && Boolean(formik.errors.code)} helperText={formik.touched.code && formik.errors.code}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='name' value={formik.values.name} title='Company Name *' multiple={false} placeholder='Enter company name' onchange={formik.handleChange} errorMsg={formik.touched.name && Boolean(formik.errors.name)} helperText={formik.touched.name && formik.errors.name}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='shortName' value={formik.values.shortName} title='Short Name *' multiple={false} placeholder='Enter short name' onchange={formik.handleChange} errorMsg={formik.touched.shortName && Boolean(formik.errors.shortName)} helperText={formik.touched.shortName && formik.errors.shortName}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='address1' value={formik.values.address1} title='Address Lines 1 *' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address1 && Boolean(formik.errors.address1)} helperText={formik.touched.address1 && formik.errors.address1}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='address2' value={formik.values.address2} title='Address Lines 2 *' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address2 && Boolean(formik.errors.address2)} helperText={formik.touched.address2 && formik.errors.address2}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='pincode' value={formik.values.pincode} title='Pincode *' multiple={false} placeholder='Enter Pincode' onchange={formik.handleChange} errorMsg={formik.touched.pincode && Boolean(formik.errors.pincode)} helperText={formik.touched.pincode && formik.errors.pincode}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <Country formik={formik} countryId={countryObj}/>
    </Grid>

    <Grid item xs={12} md={4} lg={3}>
      <State formik={formik} stateId={stateObj}/>

    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <City formik={formik} cityId={cityObj}/>

    </Grid>
    <Grid item xs={12} >
    <Divider />
    </Grid>
    <Grid item xs={12} >
      <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>2. Contact Details</Typography>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='phone' value={formik.values.phone} title='Phone No *' multiple={false} placeholder='Enter phone No' onchange={handlePhone} errorMsg={formik.touched.phone && Boolean(formik.errors.phone)} helperText={formik.touched.phone && formik.errors.phone}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='mobile' value={formik.values.mobile} title='Mobile No *' multiple={false} placeholder='Enter mobile No' onchange={handleMobile} errorMsg={formik.touched.mobile && Boolean(formik.errors.mobile)} helperText={formik.touched.mobile && formik.errors.mobile}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='email' value={formik.values.email} title='Email Id *' multiple={false} placeholder='Enter email Id' onchange={formik.handleChange} errorMsg={formik.touched.email && Boolean(formik.errors.email)} helperText={formik.touched.email && formik.errors.email}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='website' value={formik.values.website} title='Website Url *' multiple={false} placeholder='Enter website url' onchange={formik.handleChange} errorMsg={formik.touched.website && Boolean(formik.errors.website)} helperText={formik.touched.website && formik.errors.website}/>
    </Grid>
    <Grid item xs={12} >
    <Divider />
    </Grid>
      <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>3. GST Details</Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='gstin' value={formik.values.gstin} title='GSTIN *' multiple={false} placeholder='Enter gstin' onchange={formik.handleChange} errorMsg={formik.touched.gstin && Boolean(formik.errors.gstin)} helperText={formik.touched.gstin && formik.errors.gstin}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='fssai' value={formik.values.fssai} title='Pan Number *' multiple={false} placeholder='Enter Pan Number' onchange={formik.handleChange} errorMsg={formik.touched.fssai && Boolean(formik.errors.fssai)} helperText={formik.touched.fssai && formik.errors.fssai}/>
    </Grid>
    <Grid item xs={12} >
    <Divider />
    </Grid>
    <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>4. Bank Details</Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='bankAccNo' value={formik.values.bankAccNo} title='Bank Acc No *' multiple={false} placeholder='Enter Bank Acc No' onchange={handleAcc} errorMsg={formik.touched.bankAccNo && Boolean(formik.errors.bankAccNo)} helperText={formik.touched.bankAccNo && formik.errors.bankAccNo}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='bankName' value={formik.values.bankName} title='Bank Name *' multiple={false} placeholder='Enter Bank Name' onchange={formik.handleChange} errorMsg={formik.touched.bankName && Boolean(formik.errors.bankName)} helperText={formik.touched.bankName && formik.errors.bankName}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='accName' value={formik.values.accName} title='Account Holder Name *' multiple={false} placeholder='Enter Account Holder Name' onchange={formik.handleChange} errorMsg={formik.touched.accName && Boolean(formik.errors.accName)} helperText={formik.touched.accName && formik.errors.accName}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='ifscCode' value={formik.values.ifscCode} title='IFSC Code *' multiple={false} placeholder='Enter IFSC Code' onchange={formik.handleChange} errorMsg={formik.touched.ifscCode && Boolean(formik.errors.ifscCode)} helperText={formik.touched.ifscCode && formik.errors.ifscCode}/>
    </Grid>
    {/* <Grid item xx={12} md={4} lg={3} className='flex items-center'>
      <Button variant='contained' onClick={handleBank}>Add</Button>
    </Grid> */}
  </Grid>
</Modal>
}
<Grid className='my-3'>
<CustomDataGrid props={props}/>
</Grid>
<Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
</Fragment>
  )
}
export default memo(CompanyInfo)